<template>

    <div id="add-ereceipt-modal">

        <b-modal id="modal-add-code"
                 ref="modal"
                 title="Přidat eRecept kód"
                 @hidden="resetModal"
                 @ok="handleOk"
                 @shown="shownAddCodeFocus"
                 :ok-disabled="okDisabled">

            <template v-slot:modal-cancel>
                Storno
            </template>

            <form ref="form" @submit.stop.prevent="handleSubmit">
                <b-form-group :state="addEreceiptState"
                              label="Kód eReceptu"
                              label-for="name-input"
                              :invalid-feedback="addEreceiptStateMessage">

                    <b-form-input id="eReceiptCode" ref="addCodeInput"
                                  v-model="$v.addEreceiptCode.$model"
                                  :state="addEreceiptState"
                                  v-on:keyup="inputChange"
                                  min-lenght="12"
                                  autocomplete="off"
                                  :formatter="formatter"
                                  @keydown.space="(event) => event.preventDefault()"></b-form-input>
                    <span class="text-danger">{{disabledCameraText}}</span>
                </b-form-group>
            </form>

            <template v-slot:modal-header="{ close }">
                <div id="cameraButtonWrapper">
                    <b-button id="cameraButton" size="sm" :variant="showCamera ? 'danger' : 'info'" @click="switchCamera" :disabled="isCameraEnabled && disabledCameraText">
                        <i class="fa fa-camera"></i>
                    </b-button>
                </div>
                <b-tooltip target="cameraButtonWrapper" triggers="hover" v-if="!isCameraEnabled && disabledCameraText">
                    {{disabledCameraText}}
                </b-tooltip>
                <h5>Přidat eRecept kód</h5>
            </template>

            <qrcode-stream v-if="showCamera" @decode="onDecode" @init="onInit">
                <div class="loading-indicator text-center" v-if="cameraLoading">
                    <strong>Zapínám kameru...</strong>
                </div>
            </qrcode-stream>

        </b-modal>

    </div>

</template>

<script>


    import { required, email, sameAs, maxLength, minLength, minValue } from "vuelidate/lib/validators";
    import { ereceiptCodeValidatorService } from '@/services'

    var DetectRTC = require('detectrtc');

    export default {
        name: 'AddEreceiptCodeModal',
        data: function () {
            return {
                addEreceiptCode: "",
                addEreceiptState: null,
                addEreceiptStateMessage: "",
                modalFormValidFromServer: false,
                showCamera: false,
                isCameraEnabled: false,
                disabledCameraText: null,
                cameraLoading: false,
                okDisabled: false
            }
        },
        components: {
        },
        props: {
            prescriptions: {
                default: () => [],
                type: Array,
                required: false
            }
        },
        mounted: function () {
            //this.getCameraInfo();
        },
        validations: {
            addEreceiptCode: {
                required,
                maxLength: maxLength(12),
                minLength: minLength(12),
                isServerValid(value) {
                    return this.modalFormValidFromServer
                }
            }
        },
        methods: {
            formatter(value) {
                return value.toUpperCase()
            },
            async onInit(promise) {
                this.cameraLoading = true

                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.disabledCameraText = "CHYBA: musíte udělit oprávnění pro přístup ke kameře"
                    } else if (error.name === 'NotFoundError') {
                        this.disabledCameraText = "CHYBA: zařízení nemá žádnou kameru"
                    } else if (error.name === 'NotSupportedError') {
                        this.disabledCameraText = "CHYBA: vyžadován zabezpečený kontext (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.disabledCameraText = "CHYBA: zkontrolujte, zda se kamera již nepoužívá"
                    } else if (error.name === 'OverconstrainedError') {
                        this.disabledCameraText = "CHYBA: vaše kamera je nevhodná"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.disabledCameraText = "CHYBA: Stream API není v tomto prohlížeči podporován"
                    }
                }
                finally {
                    this.cameraLoading = false
                }
            },
            resetModal() {
                this.addEreceiptCode = ''
                this.addEreceiptState = null
            },
            shownAddCodeFocus() {
                this.$refs.addCodeInput.$el.focus()
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.handleSubmit()
            },
            handleSubmit() {
                let thisHelper = this;

                thisHelper.okDisabled = true;

                thisHelper.addEreceiptCode = thisHelper.addEreceiptCode.replaceAll(/\s/g, '');

                if (thisHelper.addEreceiptCode.includes(",")) {
                    let ereceptArr = thisHelper.addEreceiptCode.split(",");

                    let promisses = [];

                    _.each(ereceptArr, function (erecept) {

                        thisHelper.addEreceiptCode = erecept;

                        var exist = _.filter(thisHelper.prescriptions, function (item) { return item.code == erecept; });
                        if (exist.length > 0) {
                            console.log("Kod: " + thisHelper.addEreceiptCode + "jiz na seznamu existuje")
                            thisHelper.$v.addEreceiptCode.isUnique == false;
                            thisHelper.addEreceiptStateMessage = "Kód eReceptu je již na seznamu.";
                            thisHelper.addEreceiptState = false;
                            thisHelper.okDisabled = false;
                            return;
                        }

                        var promise = thisHelper.checkFormValidity();
 
                        promisses.push(
                            promise.then(function (ereceptIsValid) {
                                if (ereceptIsValid) {
                                    thisHelper.addEreceiptCode = thisHelper.addEreceiptCode.replace(' ', '');
                                    thisHelper.prescriptions.push({ code: erecept })
                                    Promise.resolve(promise);
                                }
                            })
                        )

                    })

                    Promise.all(promisses).then(function () {
                        thisHelper.$nextTick(() => {
                            thisHelper.$bvModal.hide('modal-add-code')
                        })

                        thisHelper.okDisabled = false;
                    }).catch(function (e) {
                        thisHelper.okDisabled = false;
                    })
                }
                else {

                    thisHelper.addEreceiptCode = thisHelper.addEreceiptCode.replace(' ', '');

                    var exist = _.filter(thisHelper.prescriptions, function (item) { return item.code == thisHelper.addEreceiptCode; });
                    if (exist.length > 0) {
                        console.log("Kod: " + thisHelper.addEreceiptCode + "jiz na seznamu existuje")
                        thisHelper.$v.addEreceiptCode.isUnique == false;
                        thisHelper.addEreceiptStateMessage = "Kód eReceptu je již na seznamu.";
                        thisHelper.addEreceiptState = false;
                        thisHelper.okDisabled = false;
                        return;
                    }

                    thisHelper.checkFormValidity().then(function (result) {
                        if (!result) return;
                      
                        thisHelper.prescriptions.push({ code: thisHelper.addEreceiptCode })
                        thisHelper.$nextTick(() => {
                            thisHelper.$bvModal.hide('modal-add-code')
                        })
                    })
                }
            },
            checkFormValidity() {
                let thisHelper = this;

                this.okDisabled = true;

                return ereceiptCodeValidatorService.isEReceiptCodeValid(thisHelper.addEreceiptCode)
                    .then(function (data) {
                        thisHelper.modalFormValidFromServer = data.data;

                        let valid = data.data;

                        thisHelper.$v.addEreceiptCode.$touch();
                        valid = !thisHelper.$v.addEreceiptCode.$invalid

                        if (!valid) {
                            if (thisHelper.$v.addEreceiptCode.required == false) {
                                thisHelper.addEreceiptStateMessage = "Kód eReceptu musí být vyplněný.";
                            }
                            else if (thisHelper.$v.addEreceiptCode.maxLength == false || thisHelper.$v.addEreceiptCode.minLength == false) {
                                thisHelper.addEreceiptStateMessage = "Kód eReceptu má obsahovat přesně 12 znaků.";
                            }
                            else if (thisHelper.$v.addEreceiptCode.isServerValid == false) {
                                thisHelper.addEreceiptStateMessage = "Kód eReceptu není validní.";
                            }
                            else if (thisHelper.$v.addEreceiptCode.isUnique == false) {
                                thisHelper.addEreceiptStateMessage = "Kód eReceptu je již na seznamu.";
                            }
                        }

                        thisHelper.addEreceiptState = valid

                        thisHelper.okDisabled = false;

                        return Promise.resolve(valid)

                    })
                    .catch(function (e) {
                        console.log("Chyba", e);
                        thisHelper.okDisabled = false;
                        return false;
                    });
            },
            inputChange() {
                if (this.$v.addEreceiptCode.$invalid) {
                    this.addEreceiptState = null;
                    this.$v.$reset;
                }
            },
            getCameraInfo() {
                let thisHelper = this;

                DetectRTC.load(function () {
                    if (DetectRTC.hasWebcam && DetectRTC.isWebsiteHasWebcamPermissions) {
                        thisHelper.isCameraEnabled = true;
                        thisHelper.disabledCameraText = null;
                    }
                    else {
                        thisHelper.isCameraEnabled = false;
                        thisHelper.showCamera = false;

                        if (!DetectRTC.hasWebcam) {
                            thisHelper.disabledCameraText = "Vaše zařízení nemá připojenou kameru.";
                        }

                        if (!DetectRTC.isWebsiteHasWebcamPermissions) {
                            thisHelper.disabledCameraText = "Nebyl udělen souhlas pro použití kamery na této stránce.";
                        }
                    }

                });
            },
            switchCamera() {
                this.showCamera = !this.showCamera;
                this.getCameraInfo();
            },
            onDecode(result) {

                this.showCamera = false;

                // pokud byl načten qr kod, tak zacina vzdy https, odtud jsme schopni si vytahnout eRecept kod
                if (result.startsWith("http")) {
                    this.addEreceiptCode = result.substring(
                        result.lastIndexOf("i=") + 2,
                        result.lastIndexOf("&d"))
                }
                else if (result.startsWith("PRUV")) {
                    let pattern = /SERP:(?<erecept>.{12})\\*/gm;
                    let matches = result.match(pattern);

                    let matchesResult = _.map(matches, function (match) {
                        return match.replace("SERP:", "");
                    }).join(',');

                    this.addEreceiptCode = matchesResult;
                }
                else { // zde byl patrně nacten ean -> co s tim?
                    this.addEreceiptCode = result;
                }
            }
        }
    }

    function sleep(delay) {
        var start = new Date().getTime();
        while (new Date().getTime() < start + delay);
    }

</script>